// Port de app/(tabs)/camera.tsx.
import { Carregando } from "@/app/Carregando";
import { useIsFocused } from "@/navigation";
import { lazy } from "react";

const PontoScreen = lazy(() => import("@/screens/Registro"));

export default function CameraRoute() {
  const focused = useIsFocused();
  return focused ? (
    <Carregando>
      <PontoScreen />
    </Carregando>
  ) : null;
}
